module.exports = __webpack_public_path__ + "img/xinzhuang-5.756061fa.jpg";